import * as React from 'react';
import clsx from 'clsx';

import './style.scss';
import { FileUtils } from 'utils';

export interface IFilesListProps {
    files: {[key: string]: {name: string, code: string, files: omjs.IObjectFieldValueFile[]}}
    className?: string;
}
export interface IFilesListState {}

class FilesListComponent extends React.Component<IFilesListProps, IFilesListState> {
    constructor(props: IFilesListProps) {
        super(props);
    }

    private getFileDisplayNameFromPath(file_path: omjs.IObjectFieldValueFile['path']) {
        return file_path.replace(/^.*[\\/]/, '');
    }

    renderFiles() {
        const { files } = this.props;

        const fileElems = [];
        // eslint-disable-next-line guard-for-in
        for (let code in files) {
            const elem = (
                <div key={code} className="file-column">
                    <div className="file-column-name">
                        {files[code].name}
                    </div>
                    {files[code].files.map(f => (
                        <div
                            key={f.id}
                            className="files-list-item"
                        >
                            <a
                                className={clsx(FileUtils.getFileExtention(f.path))}
                                href={f.path}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <div className="file-icon">
                                    { FileUtils.getFileIcon(FileUtils.getFileExtention(f.path)) }
                                </div>
                                <div className="file-name">
                                    { this.getFileDisplayNameFromPath(f.name) }
                                </div>
                            </a>
                        </div>
                    ))}
                </div>

            );
            fileElems.push(elem);
        }
        return fileElems;
    }

    render() {
        let { files } = this.props;

        if (!Object.keys(files).length) {
            return null;
        }

        return (
            <div className={clsx('files-list', this.props.className)}>
                {this.renderFiles()}
            </div>
        );
    }
}

export const FilesList = FilesListComponent;
